import { render, staticRenderFns } from "./EquipoAsignado.vue?vue&type=template&id=fd983ffe&scoped=true"
import script from "./EquipoAsignado.vue?vue&type=script&lang=js"
export * from "./EquipoAsignado.vue?vue&type=script&lang=js"
import style0 from "./EquipoAsignado.vue?vue&type=style&index=0&id=fd983ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd983ffe",
  null
  
)

export default component.exports